var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJcTsz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 9V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V9H22Z",
    fill: "#FF9500",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3H19.5858C19.851 3 20.1054 3.10536 20.2929 3.29289L21.7071 4.70711C21.8946 4.89464 22 5.149 22 5.41421V16H20V11H13L12 10L11 11H4V16H2V5.41421C2 5.149 2.10536 4.89464 2.29289 4.70711L3.70711 3.29289C3.89464 3.10536 4.149 3 4.41421 3H12Z",
    fill: "#FF9F0A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3L19.5858 3C19.851 3 20.1054 3.10536 20.2929 3.29289L21.7071 4.70711C21.8946 4.89464 22 5.149 22 5.41421V16H20V11H13L12 10M12 3H4.41421C4.149 3 3.89464 3.10536 3.70711 3.29289L2.29289 4.70711C2.10536 4.89464 2 5.149 2 5.41421V16H4V11H11L12 10M12 3V10",
    stroke: "black",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcTsz);
export default __webpack_public_path__ + "static/media/jc_tsz.0055f553b61460dcd478c47e6a4ba0e9.svg";
export { ForwardRef as ReactComponent };